@if (navigationLink()?.href ?? href()) {
  <a
    [attr.tabIndex]="tabIndex()"
    [class.hyperlink]="hyperlink()"
    [href]="navigationLink()?.href ?? href()"
    [target]="newWindow() ? '_blank' : '_self'"
    class="link__icon-alignment--{{ iconPosition() }}"
  >
    <ng-container *ngTemplateOutlet="inner" />
  </a>
} @else {
  <a
    [attr.tabIndex]="tabIndex()"
    [class.hyperlink]="hyperlink()"
    [routerLink]="navigationLink()?.routerPath ?? routerPath()"
    [target]="newWindow() ? '_blank' : '_self'"
    class="link__icon-alignment--{{ iconPosition() }}"
  >
    <ng-container *ngTemplateOutlet="inner" />
  </a>
}

<ng-template #inner>
  @if (iconName()) {
    <app-icon [name]="iconName()" [size]="'lg'" class="link__icon" />
  }

  <span class="link__label">
    @if (navigationLink()?.label) {
      <ng-container>
        {{ navigationLink()?.label }}
      </ng-container>
    } @else {
      <ng-content />
    }
  </span>
</ng-template>
